import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sub-categories"
}
const _hoisted_2 = { class: "sub-categories__caption" }

import { computed } from 'vue';

import { getContext } from '@/composables/useDynamicProductListing';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import SubCategory from '@/components/Category/SubCategory.vue';
import ScrollableContainer from '../Containers/ScrollableContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubCategories',
  setup(__props) {

const { category } = getContext();
const { websiteText } = useWebsiteTexts();

const subCategories = computed(() => {
  return category.value.children?.filter((e) => e.url && e.name) || [];
});

const hasMoreThanOneSubCategory = computed(() => {
  return subCategories.value.length > 1;
});

return (_ctx: any,_cache: any) => {
  return (_unref(hasMoreThanOneSubCategory))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(websiteText)('category__shop_by_category').value), 1),
        _createVNode(ScrollableContainer, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subCategories), (subCategory) => {
              return (_openBlock(), _createBlock(SubCategory, {
                class: "sub-categories__list-item",
                key: subCategory.url,
                subCategory: subCategory
              }, null, 8, ["subCategory"]))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})